import TipTapHardBreak from '@tiptap/extension-hard-break'

export default TipTapHardBreak.extend({
  name: 'hard_break',
})
